import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TalentSelection } from "../../components/project/TalentSelection";
import { zoullooColors } from "../../theme";
import { PUBLIC_LINK_TTL_DAYS } from "../../constants/talentSelection";

/**
 * "Nouvelle sélection" wizard for outbound prospecting (Option B).
 *
 * Mounts the same `<TalentSelection />` component the recruiter uses on
 * `/talent-search`, but framed with a header that makes the intent explicit:
 * the CSM is about to build a SHARED selection that will produce one public,
 * anonymized link per talent — not invite anyone to a project.
 *
 * Functionally, this is the same surface as `/talent-search` (no projectId);
 * the duplication is intentional UX: a different menu entry, a different
 * mental model, a different header — same underlying building blocks.
 */
const NewProspectSelection: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Box>
			<Box px={{ xs: 2, sm: 4, md: 6 }} pt={3} pb={1}>
				<Typography
					variant="h4"
					sx={{
						fontWeight: 600,
						color: zoullooColors.secondary.dark,
						mb: 0.5
					}}
				>
					{t("anonymizedTalent.prospectionWizardTitle")}
				</Typography>
				<Typography
					sx={{
						fontSize: 14,
						color: zoullooColors.text.secondary
					}}
				>
					{t("anonymizedTalent.prospectionWizardSubtitle", {
						days: PUBLIC_LINK_TTL_DAYS
					})}
				</Typography>
			</Box>
			<TalentSelection />
		</Box>
	);
};

export default NewProspectSelection;
